export const ARTIFACTS_SECTION_TITLE = 'Artifacts'

export const ARTIFACT_EMPTY_STATE_LABELS = {
  filteredTitle: 'No artifacts found',
  zeroDataTitle: 'No artifacts available',
} as const

export const ARTIFACT_VIEW_LABELS = {
  active: 'Active',
  archived: 'Archived',
}

/** Singular; BulkActionsBar pluralizes against the selected count. */
export const BULK_DOWNLOAD_ENTITY_LABEL = 'file'

export const BULK_DOWNLOAD_ACTION_LABEL = 'Download'
export const BULK_DOWNLOAD_PENDING_LABEL = 'Preparing…'

/** Sits after the selected count, e.g. "52 files selected, 40 downloadable". */
export const bulkDownloadableDetail = (count: number) => `${count} downloadable`
